import { ChangeDetectionStrategy, Component, HostListener, input } from '@angular/core';
import { Header } from '../../models/header.model';
import { IconComponent } from '@teamfoster/sdk/icon';
import { LinkComponent } from '@teamfoster/sdk/button';
import { FeaturedEventCardComponent } from 'src/app/events/components/featured-event-card/featured-event-card.component';
import { CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { NgClass, SlicePipe } from '@angular/common';
import { trigger } from '@angular/animations';
import { CardGridAnimation } from 'src/app/animations';

import { InViewModule } from '@teamfoster/sdk/in-view';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-header-card-grid',
  imports: [
    IconComponent,
    LinkComponent,
    FeaturedEventCardComponent,
    SlicePipe,
    InViewModule,
    NgClass,
    ResizeHtmlImagesPipe,
    StripEmbedPipe,
    SafePipe,
  ],
  templateUrl: './header-card-grid.component.html',
  styleUrl: './header-card-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('CardGridAnimation', [CardGridAnimation])],
})
export class HeaderCardGridComponent {
  header = input.required<Header>();
  cookiePreferences = input<CookiePreferences>();

  get cssClassesGallery() {
    //const events = this.header().events;

    switch (this.galleryLength) {
      case 1:
        return 'gallery--1';
      case 2:
        return 'gallery--2';

      case 3:
        return 'gallery--3';

      default:
        return 'no--gallery';
    }
  }

  get galleryLength() {
    return this.header().events?.length;
  }
}
